import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaArrowDown, FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { personalInfo, socialLinks } from "../../data/portfolioData";
import InteractiveParticles from "./InteractiveParticles";
import { useLanguage } from "../../context/LanguageContext";
import "./Hero.css";

const Hero = () => {
  const [typed, setTyped] = useState('');
  const [typingDone, setTypingDone] = useState(false);
  const { language, t } = useLanguage();

  useEffect(() => {
    const fullText = t.hero.tagline;
    setTyped("");
    setTypingDone(false);
    let i = 0;
    let iv;
    const delay = setTimeout(() => {
      iv = setInterval(() => {
        setTyped(fullText.slice(0, i + 1));
        i++;
        if (i >= fullText.length) {
          clearInterval(iv);
          setTypingDone(true);
        }
      }, 45);
    }, 1100);
    return () => {
      clearTimeout(delay);
      clearInterval(iv);
    };
  }, [t.hero.tagline]);

  return (
    <section className="hero" id="home">
      <InteractiveParticles />

      <div className="hero__container">
        <div className="hero__content">
          <p className="hero__greeting animate-fade-up">{t.hero.greeting}</p>
          <h1 className="hero__name">
            {personalInfo.name}
          </h1>
          <h2 className="hero__tagline animate-fade-up delay-2">
            {typed}
            <span className={`hero__cursor${typingDone ? ' hero__cursor--blink' : ''}`}>|</span>
          </h2>
          <p className="hero__intro animate-fade-up delay-3">
            {t.hero.intro}
          </p>
          <p className="hero__location animate-fade-up delay-3">
            📍 {personalInfo.location}
          </p>

          <div className="hero__cta animate-fade-up delay-3">
            <Link
              to="projects"
              smooth={true}
              offset={-70}
              duration={500}
              className="btn btn--primary"
            >
              {t.hero.work}
            </Link>
            <a
              href={personalInfo.resumeUrls[language]}
              target="_blank"
              rel="noreferrer"
              className="btn btn--outline"
              download={`Safouane_Rady_CV_${language.toUpperCase()}.pdf`}
            >
              {t.hero.resume}
            </a>
            <Link
              to="contact"
              smooth={true}
              offset={-70}
              duration={500}
              className="btn btn--outline"
            >
              {t.hero.contact}
            </Link>
          </div>

          <div className="hero__socials animate-fade-up delay-4">
            <a href={socialLinks.github} target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={socialLinks.gmail} className="hero__social-link" aria-label={`Email ${personalInfo.email}`}>
              <FaEnvelope />
            </a>
          </div>
        </div>

        <div className="hero__image-wrapper animate-fade-up delay-2">
          <div className="hero__image-float">
            <div className="hero__image-border">
              <img
                src={personalInfo.profileImage}
                alt={personalInfo.name}
                className="hero__image"
              />
            </div>
          </div>
        </div>
      </div>

      <Link
        to="about"
        smooth={true}
        offset={-70}
        duration={500}
        className="hero__scroll-down"
      >
        <FaArrowDown />
      </Link>
    </section>
  );
};

export default Hero;
